import { IonContent, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../components/header/page.header';
import { Onboarding } from '../../components/onboarding/onboarding';
import './home.css';

const Home = (): ReactElement => {
  const { i18n } = useTranslation();
  return (
    <IonPage>
      <PageHeader title={i18n.t('common:home')} />
      <IonContent>
        <Onboarding />
      </IonContent>
    </IonPage>
  );
};

export default Home;
